export enum CreatureCategory {
  PET = 'pet',
  PLANET = 'planet',
  HERO = 'hero',
  MYTHICAL = 'mythical'
}

export enum CreaturePose {
  IDLE = 'idle',
  HAPPY = 'happy',
  SAD = 'sad',
  BATTLE = 'battle',
  LEVELUP = 'levelup'
}

export enum LeagueTier {
  WOOD = 'wood',
  BRONZE = 'bronze',
  SILVER = 'silver',
  GOLD = 'gold',
  DIAMOND = 'diamond'
}

export interface CreatureType {
  id: string;
  name: BilingualText;
  category: CreatureCategory;
  baseColor: string;
  svgPaths: {
    [key in CreaturePose]: string; // path to SVG file for each pose
  };
}

export interface ClassCreature {
  creatureTypeId: string;
  customName: string;
  totalXP: number;
  level: number;
  league: LeagueTier;
  currentStreak: number;
  bestStreak: number;
  totalCorrect: number;
  totalAnswered: number;
  classId: number;
  className?: string;
}

export interface CreatureOnMap {
  classId: number;
  className: string;
  gradeName: string;
  creature: ClassCreature;
  creatureType: CreatureType;
  isOnline: boolean;
}

export interface GradeCastle {
  gradeId: number;
  gradeName: string;
  classes: CreatureOnMap[];
  topCreature: ClassCreature | null;
  topCreatureType: CreatureType | null;
  league: LeagueTier;
  averageLevel: number;
  isExpanded: boolean;
}

interface BilingualText {
  en: string;
  ar: string;
}
